import { isPlatformBrowser } from '@angular/common';
import { inject, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { CacheService } from '../../../ssr-services/cache/cache.service';

export const SHOW_NOT_FOUND = makeStateKey<boolean>('SHOW_NOT_FOUND');

export const setupCacheGuard: CanActivateFn = () => {
  const platform = inject(PLATFORM_ID);
  const router = inject(Router);
  const transferState = inject(TransferState);

  if (isPlatformBrowser(platform)) {
    return transferState.get(SHOW_NOT_FOUND, false)
      ? router.navigate(['404'], { skipLocationChange: true })
      : true;
  }

  const cacheService = inject(CacheService);

  return from(cacheService.initCacheInServer())
    .pipe(map(() => true))
    .pipe(
      catchError((err) => {
        console.error(err);
        transferState.set(SHOW_NOT_FOUND, true);
        return of(false);
      })
    )
    .pipe(
      switchMap((result) =>
        result
          ? of(true)
          : router.navigate(['404'], {
              replaceUrl: true,
            })
      )
    );
};
